import { z } from 'zod'

export const MEDIA_TYPES = ['banner', 'video', 'native'] as const

export const MediaTypeSchema = z.enum(MEDIA_TYPES)
export type MediaType = z.infer<typeof MediaTypeSchema>
